export default "__VITE_ASSET__CXlmjWAq__"